var _rect, _rect2, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.490283,
    y: 0.490283,
    width: 36.281,
    height: 36.281,
    rx: 18.1405,
    transform: "matrix(-1 0 0 1 36.2812 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.490283,
    y: 0.490283,
    width: 36.281,
    height: 36.281,
    rx: 18.1405,
    transform: "matrix(-1 0 0 1 36.2812 0)",
    stroke: "#EFECE7",
    strokeWidth: 0.980566
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2079_1631",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5254 18.6301L20.5928 11.6975L13.6602 18.6301L20.5928 25.5627L27.5254 18.6301Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6602 18.6301L12.2734 20.0169L10.8867 18.6301L12.2734 17.2434L13.6602 18.6301ZM21.9795 13.0842L15.0469 20.0169L12.2734 17.2434L19.206 10.3108L21.9795 13.0842ZM15.0469 17.2434L21.9795 24.176L19.206 26.9495L12.2734 20.0169L15.0469 17.2434Z",
    fill: "black",
    mask: "url(#path-2-inside-1_2079_1631)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowIcon);
export default __webpack_public_path__ + "static/media/leftArrowIcon.287ad8676737caaf53050fee5a9a7ebc.svg";
export { ForwardRef as ReactComponent };